import {createContext, ReactNode, useContext} from "react";

import {useChecksListViews} from "@/pages/checks/list/columns/useChecksListViews.ts";

type ChecksListViewsContextValue = ReturnType<typeof useChecksListViews>;

const ChecksListViewsContext = createContext<ChecksListViewsContextValue | null>(null);

export const useChecksListViewsContext = (): ChecksListViewsContextValue => {
  const context = useContext(ChecksListViewsContext);
  if (!context) {
    throw new Error("useChecksListViewsContext must be used within a ChecksListViewsProvider");
  }
  return context;
};

interface ChecksListViewsProviderProps extends ChecksListViewsContextValue {
  children: ReactNode;
}

export const ChecksListViewsProvider = ({children, ...rest}: ChecksListViewsProviderProps) => {
  return <ChecksListViewsContext.Provider value={{...rest}}>{children}</ChecksListViewsContext.Provider>;
};
